export const RETRIEVE_VOLUMES = 'commercial/volumes/retrieve';

export const RETRIEVE_VOLUME = 'commercial/volumes/getById';
